import { FACET_KEY_ARTISTS, FACET_KEY_TAGS, FACET_KEY_TYPES } from '../constants/facetKeys';
import { PER_ROW_LESS, PER_ROW_MORE } from '../constants/perRowKeys';
import { MEDIA_BREAKPOINTS } from '../../constants/MEDIA_BREAKPOINTS';
const isPerRowLessAB = window.Cookies.get('perRowLessAB') ?? false;
export const itemsPerRow = isPerRowLessAB
    ? PER_ROW_LESS
    : !MEDIA_BREAKPOINTS.MD_UP.matches ? PER_ROW_LESS : PER_ROW_MORE;
export const fullListOfItemsForFacets = [
    [
        'layouts.pieces',
        {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0
        }
    ],
    [
        'layouts.shape',
        {
            horizontal: 0,
            panoramic: 0,
            square: 0,
            vertical: 0
        }
    ]
];
export const typesFacetConfig = {
    key: FACET_KEY_TYPES,
    name: 'Product Type',
    singleSelect: true,
    style: 'icons'
};
const pageConfigs = window.algAppConfigs;
export const useAnalytic = window.location.hostname !== 'www.elephantstock.com'
    ? false
    : pageConfigs.useAnalytic ?? true;
export const showFilterByTypes = pageConfigs.showFilterByTypes ?? true;
export const activeFacetConfigs = pageConfigs.listOfFacets;
export const activeSortConfigs = pageConfigs.listOfSorting;
export const searchableAttributes = pageConfigs.searchableAttributes;
export const queryLetter = (window.location.search.match(/[?&]([a-z])=/) ?? [])[1] ?? 'q';
export const capsuleItemsArr = pageConfigs.collection?.capsuleItems ?? [];
export const isCapsuleCollection = capsuleItemsArr.length > 0;
export const nbItemsPerPage = isCapsuleCollection ? 48 : 47;
export const defaultSearchParams = {
    index: pageConfigs.defaultIndex,
    filters: pageConfigs.defaultFilters ?? '',
    facets: pageConfigs.defaultFacets ?? {},
    query: pageConfigs.defaultQuery ?? ''
};
export const hierarchyObjects = pageConfigs.hierarchyObjects ?? {};
export const hierarchyFacetKey = pageConfigs.hierarchyFacetKey ?? '';
export const customBreadcrumbSteps = pageConfigs.customBreadcrumbSteps;
export const templateSuffix = pageConfigs.templateSuffix;
export const collectionData = {
    title: pageConfigs.collection?.title ?? 'Search',
    image: pageConfigs.collection?.image ?? '',
    staticDescription: pageConfigs.collection?.staticDescription,
    artistDescription: pageConfigs.collection?.artistDescription
};
export const supplementaryData = pageConfigs.supplementaryData ?? {};
export const sortConfigByNameOrIndex = {};
activeSortConfigs.forEach(sort => {
    sortConfigByNameOrIndex[sort.name.toLowerCase()] = sort;
    sortConfigByNameOrIndex[sort.index] = sort;
});
export const listOfAllFacetKeys = [];
activeFacetConfigs.forEach(({ key, hierarchy, additionalKeys }) => {
    if (hierarchy !== undefined) {
        for (let i = 1; i <= hierarchy; i++) {
            listOfAllFacetKeys.push(`${key}_lv${i}`);
        }
    }
    else {
        listOfAllFacetKeys.push(key);
    }
    if (additionalKeys !== undefined && additionalKeys.length > 0) {
        listOfAllFacetKeys.push(...additionalKeys);
    }
});
if (showFilterByTypes) {
    listOfAllFacetKeys.push(FACET_KEY_TYPES);
}
listOfAllFacetKeys.push(FACET_KEY_TAGS);
!listOfAllFacetKeys.includes(FACET_KEY_ARTISTS) && listOfAllFacetKeys.push(FACET_KEY_ARTISTS);
